import { NameInputChange } from "@screens/Expenses";
import { useState } from "react";
import InputSelect from "../Receipt/select";
import { useT } from "@hooks";
import SharedCreateDialog, { CategoryTypeTooltip, isDuplicatedName } from "../SharedCreateDialog";

interface Props {
  show: boolean;
  onClose: () => void;
  onSave: (value: string, selectValue?: string) => void;
  title: string;
  placeholder: string;
  existingNames?: string[];
  duplicateNameMessage?: string;
}

const DialogCreateCategory = ({
  show,
  onClose,
  onSave,
  title,
  placeholder,
  existingNames = [],
  duplicateNameMessage = "",
}: Props) => {
  const t = useT();
  const categoryOptions = [
    { id: "DIRETO", label: t("dialog.category.direct") },
    { id: "OPERACIONAL", label: t("dialog.category.operational") },
  ];
  const [error, setError] = useState("");
  const [errorSelect, setErrorSelect] = useState("");

  const [valueCategory, setValueCategory] = useState("");
  const [selectCategory, setSelectCategory] = useState("");

  const isDuplicateName = isDuplicatedName(valueCategory, existingNames);

  const handleSubmit = () => {
    if (!valueCategory || !selectCategory) {
      if (!valueCategory) {
        setError(t("common.label.requiredField"));
      }
      if (!selectCategory) {
        setErrorSelect(t("common.label.requiredField"));
      }
      return;
    }

    if (isDuplicateName) return;

    setError("");
    setErrorSelect("");

    setValueCategory("");
    setSelectCategory("");

    onSave(valueCategory, selectCategory);
  };

  const handleClose = () => {
    onClose();
    setValueCategory("");
    setSelectCategory("");
  };

  const inputChange = (name: NameInputChange, value?: string) => {
    setSelectCategory(value || "");
  };

  return (
    <SharedCreateDialog
      show={show}
      title={title}
      placeholder={placeholder}
      value={valueCategory}
      onValueChange={setValueCategory}
      error={error}
      isDuplicateName={isDuplicateName}
      duplicateNameMessage={duplicateNameMessage}
      onClose={handleClose}
      onSubmit={handleSubmit}
      useOverflow
      fieldsAfter={
        <div className={`form-group ${errorSelect ? "has-feedback has-error" : ""}`}>
          <InputSelect
            inputChange={inputChange}
            label={t("dialog.category.typeQuestion")}
            name="category"
            onCreateNewOption={() => {}}
            options={categoryOptions}
            value={selectCategory}
            errorMessage={errorSelect}
            tooltip={<CategoryTypeTooltip />}
          />
        </div>
      }
    />
  );
};

export default DialogCreateCategory;
